import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { fetchDefault } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import HowPayDialog from './seat/HowPayDialog';


const useStyles = makeStyles(theme => ({
    textField: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(1),
        width: 200,
    },
    menu: {
        width: 180,
    },
}));

const moneyList = [
    {
        value: 3000,
        label: '3000원',
    },
    {
        value: 5000,
        label: '5000원',
    },
    {
        value: 10000,
        label: '10,000원',
    },
    {
        value: 20000,
        label: '20,000원',
    },
    {
        value: 30000,
        label: '30,000원',
    },
    {
        value: 50000,
        label: '50,000원',
    },
    {
        value: 100000,
        label: '100,000원',
    },
    {
        value: 120000,
        label: '120,000원',
    },
    {
        value: 150000,
        label: '150,000원',
    },
    {
        value: 200000,
        label: '200,000원',
    },
    {
        value: 250000,
        label: '250,000원',
    },
    {
        value: 300000,
        label: '300,000원',
    },
    {
        value: 400000,
        label: '400,000원',
    },
    {
        value: 500000,
        label: '500,000원',
    },
    {
        value: 800000,
        label: '800,000원',
    },
    {
        value: 1000000,
        label: '1,000,000원',
    },
];


export default function ChargeMoney() {
    const classes = useStyles();
    let history = useHistory();

    const [money, setMoney] = React.useState(10000);


    const [isSelected, setIsSelected] = React.useState(false);
    const handleChange = event => {
        setMoney(event.target.value);

        //if (!isSelected) {
        //    setMoney(event.target.value);

        //    setTimeout(function () { setIsSelected(false); }, 1000);
        //}
        //setIsSelected(true);
    };



    useEffect(() => {


        return () => {
        }
    }, []);

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>잔액 충전하기</h2>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="body1">
                                충전된 금액은 제한 기간 없이 모든 메뉴에서 사용 가능합니다.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 충전을 원하시는 금액을 입력해주세요. (계좌이체로 10,000원 이상 충전 시 5% 추가 충전됩니다.)
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        label="충전금액(원)"
                        className={classes.textField}
                        value={money}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                    >
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <HowPayDialog usePoint={0} totalPrice={money} controllerUrl={'/Payment/ChargeMoney?money=' + money} chargeOnly={true} />
                </Grid>

            </Grid>

        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/ChargeMoney.js